var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletTransferIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#1C2127"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3446 24.5035H30.4443V22.2267C30.4443 21.3438 29.7299 20.6294 28.847 20.6294C25.7309 21.4048 22.6176 22.1134 19.5015 22.8685C18.6186 23.0834 18 23.8733 18 24.7823C18 29.2606 18 33.9885 18 38.4029C18 39.2857 18.7144 40.0002 19.5973 40.0002H37.3446C38.2275 40.0002 38.9419 39.2857 38.9419 38.4029V26.1037C38.9448 25.2209 38.2275 24.5035 37.3446 24.5035ZM28.8964 22.1802V24.5035H19.5508L28.8964 22.1802ZM37.394 34.5752H28.0978V29.9256H37.394V34.5752ZM37.394 28.3777H28.0717V29.9285H26.547V34.5287C26.547 35.4116 27.2614 36.126 28.1443 36.126H37.394V38.4493H19.5508V26.0544H37.394V28.3777Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2921 31.4761H31.1904V33.0269H34.2921V31.4761Z",
    fill: "#2764FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5117 20.9313L35.5853 20.0019L34.8157 20.7715V16H33.503V20.7657L32.6608 19.9235L31.7314 20.8499L34.1622 23.2807L36.5117 20.9313Z",
    fill: "#2764FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletTransferIcon);
export default __webpack_public_path__ + "static/media/wallet-transfer-icon.9ac453c8f42bf00ebc526a3ade2d6c11.svg";
export { ForwardRef as ReactComponent };